import { get } from "@ember/object"
import ENV from "../../../config/environment"

export default function (actionStream) {
  actionStream.onValue(([type, _payload, actionDoc]) => {
    if (type === "REGISTER_COMPONENT" || type === "DEREGISTER_COMPONENT") return
    if (get(actionDoc, "attributes.narrative.isQuiet")) return
    if (window._LOG_PAYLOAD_ACTION_) {
      console.log(
        "🚀 " + type,
        `${get(actionDoc, "attributes.narrative.title")} - ${get(
          actionDoc,
          "attributes.narrative.description"
        )}. (Analytics Title: ${get(actionDoc, "attributes.narrative.titleForAnalytics")})`,
        actionDoc
      )
      // Only log in development or if Raven isn't defined (which would be in dev and )
    } else if (ENV.environment === "development") {
      console.log(
        "🚀 " + type,
        `${get(actionDoc, "attributes.narrative.title")} - ${get(
          actionDoc,
          "attributes.narrative.description"
        )}. (Analytics Title: ${get(actionDoc, "attributes.narrative.titleForAnalytics")})`
      )
    }
  })
}
